import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, Link } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { StyleSheet, css } from 'aphrodite';

import { Controller } from './common/Controller';
import { AppTheme, AppStyles } from './styles/AppTheme';

import { Header } from './components/Header';
import { Footer } from './components/Footer';

import { DashboardAdmin } from './screens/DashboardAdmin';
import { Login } from './screens/Login';
import { NotFound } from './screens/NotFound';
import { Terms } from './screens/Terms';
import { Privacy } from './screens/Privacy';
import { Sections } from './common/components/quizcreator/Sections';
import { SubSections } from './common/components/quizcreator/SubSections';
import { Questions } from './common/components/quizcreator/Questions';
import { Options } from './common/components/quizcreator/Options';
import { Respond } from './common/components/quizresponder/Respond';
import { UiHelper } from './common/helpers/UiHelper';
import { RespondV2 } from './common/components/quizresponder/RespondV2';
import { SurveyHome } from './screens/SurveyHome';
import { Settings, Docs } from './screens/admin/Docs';
import { Stats } from './screens/Stats';
import { SurveySubmits } from './screens/SurveySubmits';
import { Home } from './screens/Home';
import { SurveySection } from './screens/SurveySection';
import { MainHeader } from './components/MainHeader';
import { Introduction } from './screens/Introduction';
import { Profile } from './screens/Profile';
import { AppHelper } from './helpers/AppHelper';
import { AppConfig } from './AppConfig';
import { Intros } from './screens/admin/Intros';
import { Maintenance } from './screens/Maintenance';
import { Exports } from './screens/admin/Exports';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: AppTheme.secondaryColor //TODO: need to define primary and seconday properly
    },
    secondary: {
      main: AppTheme.secondaryColor
    }
  },
  typography: {
    fontFamily: [
      'Montserrat',
      'sans-serif'
    ].join(',')
  }
});

const PublicRoute = (props) => {
  if (Controller.get().loginMgr().getCurrentUser()) {
    if (props && props.path === '/login') {
      return <Redirect to={Controller.get().getHomeByRole()} />
    }
  }
  // if (props && props.path === '/') {
  //   return <Redirect to="/login" />
  // }
  return <Route {...props} />
}

const ProtectedRoute = (props) => {
  if (Controller.get().loginMgr().getCurrentUser()) {
    if (props.userLoaded) {
      if(AppHelper.isProfileCompleteAndpreReqCheckPassed() ||
      props.path === AppConfig.clientProfile) {
        return <Route {...props} />
      } else {
        return <Redirect to={AppConfig.clientProfile} />
      }
    }
    Controller.get().loginMgr().bootstrap((err, data) => {
      if (err) {
        console.error('bootstrap err:', err)
        return
      }
      //console.log('bootstrap OK:', Controller.get().getUserId())
      props.setUserLoaded && props.setUserLoaded()
    })
    return (
      UiHelper.componentLoadingView() //user may not
      // <Route {...props} />
    )
  } else {
    return <Redirect to='/login' />
  }
}

class App extends Component {

  constructor(props) {
    //console.log('App::constructor')
    super(props);
    this.state = {
      currentUser: Controller.get().loginMgr().getCurrentUser()
    };
  }

  setUserLoaded = () => {
    this.setState({ userLoaded: true, currentUser: Controller.get().loginMgr().getCurrentUser() })
  }

  render() {
    return (
      <Router>
        <MuiThemeProvider theme={theme}>
          <Route path={'/'} component={({ location, history }) => {
            if (AppConfig.MAINTENANCE_HOST && window.location.hostname === AppConfig.MAINTENANCE_HOST) {
              return (
                <Route component={Maintenance} />
              )
            }
            return (
              <div className={css(Styles.page)}>
                {this.state.currentUser &&
                  Controller.get().userMgr().isProductSU() &&
                  <Header
                    className={css(Styles.header)}
                    currentUser={this.state.currentUser}
                    homeLink={this.getUserHomeLink()}
                    onDashboardClick={() => this.onDashboardClick()}
                    onLogoutClick={() => this.onLogoutClick()} />
                }
                {(this.state.currentUser  ||
                  history.location.pathname === '/introduction' || history.location.pathname === '/profile') &&
                  !Controller.get().userMgr().isProductSU() &&
                  <MainHeader
                    path={history}
                    className={css(Styles.header)}
                    currentUser={this.state.currentUser}
                    homeLink={this.getUserHomeLink()}
                    onDashboardClick={() => this.onDashboardClick()}
                    onLogoutClick={() => this.onLogoutClick()}
                  />
                }

                <div
                  className={!history.location.pathname.startsWith('/survey')
                    ? css(Styles.content) : css(Styles.content, Styles.regularUserContent)}>
                  {this.renderRoute(history)}
                </div>

                {/* <Footer className={css(Styles.footer)} /> */}

              </div>
            );
          }}
          />
        </MuiThemeProvider>
      </Router>
    );
  }

  renderRoute(history) {
    Controller.get().setNavigator(history); //TODO should this be given here?
    const props = {
      userLoaded: this.state.userLoaded,
      setUserLoaded: this.setUserLoaded
    }
    return (
      <Switch>
        <ProtectedRoute {...props} exact path={'/admin'} component={DashboardAdmin} />

        <ProtectedRoute {...props} exact path={'/admin/quiz/:quizId'} component={Sections} />
        <ProtectedRoute {...props} exact path={'/admin/docs'} component={Docs} />
        <ProtectedRoute {...props} exact path={'/admin/intros'} component={Intros} />
        <ProtectedRoute {...props} exact path={'/admin/consumers'} component={Stats} />
        <ProtectedRoute {...props} exact path={'/admin/submits'} component={SurveySubmits} />
        <ProtectedRoute {...props} exact path={'/admin/exports'} component={Exports} />

        <ProtectedRoute {...props} exact path={'/admin/quiz/:quizId/:secId'} component={SubSections} />
        <ProtectedRoute {...props} exact path={'/admin/quiz/:quizId/:secId/:subId'} component={Questions} />
        {/* <ProtectedRoute {...props} exact path={'/admin/quiz/:quizId/:secId/:subId/questions/:qId/options'} component={Options} />
        <ProtectedRoute {...props} exact path={'/admin/quiz/:quizId/:secId/:subId/questions/:qId/options/:optionId/branch'} component={Questions} /> */}
        {/* <ProtectedRoute {...props} exact path={'/respond'} component={Respond} />
        <ProtectedRoute {...props} exact path={'/respondv2'} component={RespondV2} /> */}

        <ProtectedRoute {...props} exact path={'/survey'} component={SurveyHome} />
        <ProtectedRoute {...props} exact path={'/survey-sections/:id'} component={SurveySection} />

        <PublicRoute path='/login' component={Login} />
        <PublicRoute exact path={'/'} component={Home} />
        <PublicRoute exact path={'/introduction'} component={Introduction} />
        <ProtectedRoute {...props} exact path={'/profile'} component={Profile} />

        {/*<Route exact path = {'/survey-sections/:id'} component={SurveySection} />
        <Route exact path = {'/survey'} component={SurveyHome} />*/}
        <Route exact path={'/terms'} component={Terms} />
        <Route exact path={'/privacy'} component={Privacy} />
        {/*<Route exact path = {'/'} component={Home} />*/}
        <Route component={NotFound} />
      </Switch>
    )
  }

  onLogoutClick() {
    //console.log('onLogoutClick');
    Controller.get().loginMgr().signOut();
    this.setState({
      currentUser: null
    })
  }

  onDashboardClick() {
    this.props.history.push('/admin');
  }

  getUserHomeLink = function () {
    return '/admin'
  }
}

const Styles = StyleSheet.create({
  page: {
    // height: '100%',
    backgroundColor: AppTheme.primaryBg,
  },
  header: {
    flex: '0 0 auto'
  },
  regularUserContent: {
    marginTop: AppTheme.toolbarHeight * -1.6,
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    //paddingTop: 20, // for header
    //paddingBottom: 60, // for footer
    // minHeight: 600,
    overflowX: 'hidden',
    //flex: '1 1 auto',
    //position: 'relative', //need this to position inner content
    //overflowY: 'auto',
    //marginTop: -140,
    // height: '100vh',
    '@media (max-width: 767px)': {
      marginTop: 0,
      paddingTop: 0,
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      marginTop: 0,
      paddingTop: 0,
    },
  },
  footer: {
    flex: '0 0 auto'
  }
})

export default App;



// WEBPACK FOOTER //
// ./src/App.js